import styled from "styled-components";
import media from "constants/media";

export const AddPackageStyled = styled.button`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    margin-top: 30px;
    padding: 15px 20px;

    font-size: 14px;
    line-height: 20px;
    text-align: left;

    background-color: var(--color-white);
    box-shadow: 3px 3px 7px 0 rgba(0, 23, 75, 0.05);

    cursor: pointer;

    ${media.smUp`
        padding: 25px 30px;
    `}

    ${media.mdUp`
        padding: 35px 40px;

        font-size: 15px;
        line-height: 25px;
    `}
`;

export const Icon = styled.img`
    width: 16px;
    height: auto;
    margin: 4px 22px 0 0;
`;
